import { render, staticRenderFns } from "./shops.vue?vue&type=template&id=21ce7f78&"
import script from "./shops.vue?vue&type=script&lang=js&"
export * from "./shops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports